export default [
  { title: "adminSections.companies", pathName: "Companies" },
  { title: "adminSections.stores", pathName: "Stores" },
  { title: "adminSections.layouts", pathName: "Layouts" },
  { title: "adminSections.settings", pathName: "Settings" },
  { title: "adminSections.campaignManager", pathName: "CampaignManager" },
];
